import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { PillControl } from '@bingads-webui-react/pill-control';

import { pillControlStyle } from './pill-control-style';

const getScopeSelectorContainerStyles = (selector, { palette }) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: '15px',
    alignItems: 'stretch',
  },
  typePicker: {
    border: '1px solid transparent',
    marginTop: '12px',
    marginRight: '8px',
    marginBottom: '12px',
    verticalAlign: 'middle',
  },
  pillControl: Object.assign(
    {
      marginTop: '8px',
      marginRight: '8px',
      marginBottom: '8px',
    },
    pillControlStyle({ palette })
  ),
  subMenuSeparator: {
    height: '1px',
    border: 'none',
    backgroundColor: palette.neutralLighter,
  },
});

class ScopeSelector extends React.PureComponent {
  constructor(props) {
    super(props);

    // make classNames
    this.scopeSelectorClassName = classNames([
      props.classes.container,
      props.customClasses.scopeSelectorCustomClass,
    ]);
    this.typePickerClassName = classNames([
      props.classes.typePicker,
      props.customClasses.typePickerCustomClass,
    ]);
    this.pillControlClassName = classNames([
      props.classes.pillControl,
      props.customClasses.pillControlCustomClass,
    ]);
  }

  render() {
    let typePicker = null;
    let pillControl = null;

    if (this.props.typePicker) {
      typePicker = <div className={this.typePickerClassName}>{this.props.typePicker}</div>;
    }

    pillControl = (
      <PillControl
        className={this.pillControlClassName}
        defaultSelectedIndex={this.props.pillControlParams.levelIndex}
        onItemChange={this.props.pillControlParams.onItemChange}
        items={this.props.pillControlParams.levelItems}
      />
    );

    return (
      <div className="scope-selector">
        <div className={this.scopeSelectorClassName}>
          <div className="type-picker">
            {typePicker}
          </div>
          {pillControl}
        </div>
        {
        this.props.hideSubMenuSeparator ?
        null : <div className={this.props.classes.subMenuSeparator} />
        }
      </div>
    );
  }
}

ScopeSelector.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
    typePicker: PropTypes.string.isRequired,
    pillControl: PropTypes.string.isRequired,
    subMenuSeparator: PropTypes.string.isRequired,
  }).isRequired,
  hideSubMenuSeparator: PropTypes.bool,
  pillControlParams: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  typePicker: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  customClasses: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

ScopeSelector.defaultProps = {
  typePicker: null,
  customClasses: {},
  hideSubMenuSeparator: false,
};

export const StyledScopeSelector = withDefaultStyles(
  ScopeSelector,
  getScopeSelectorContainerStyles
);
